import styled from 'styled-components'

import { helpers } from 'styles'

type Props = {
	align: 'left' | 'right' | 'center'
}

export const AlignmentWrapper = styled.div<Props>`
	display: flex;
	align-items: center;
	text-align: ${({ align }) => align};
	justify-content: ${({ align }) => {
		switch (align) {
			case 'left':
				return 'flex-start'
			case 'right':
				return 'flex-end'
			default:
				return 'center'
		}
	}};
	gap: 12px;
	color: ${helpers.color.textContrast};
`
